import {http} from '../utils'

const auditLogPage = params => {
  const url = '/config/notice/log'
  return http.post(url, params)
}

export default {
  auditLogPage,
}
